import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";

/**
 * Staffelpreis-Tabelle.
 *
 * Hebt die Zeile hervor, die zur aktuell eingestellten Menge passt — sonst muss
 * der Kunde selbst nachrechnen, in welcher Stufe er gerade liegt.
 *
 * Der Mengenwert kommt aus dem Eingabefeld des Themes
 * (`input.quantity-input`, siehe snippets/quantity-selector.liquid). Beobachtet
 * wird die Section, nicht das Feld selbst: Das Theme rendert den Bereich beim
 * Variantenwechsel neu, ein direkt gebundener Listener wäre danach tot.
 */
class StaffelpreiseTabelle extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.sectionId = this.dataset.sectionId;
    this.zeilen = Array.from(this.querySelectorAll(".staffel__zeile"));

    // Menge immer aus dem Feld lesen, egal welches Ereignis sie gemeldet hat.
    this.onAenderung = () => this.#hervorheben(this.#aktuelleMenge());

    // Die Plus/Minus-Knöpfe des Themes setzen den Wert per JavaScript — dabei
    // feuert KEIN input-Event. Das Theme meldet die Änderung stattdessen über
    // ein eigenes Ereignis (assets/events.js: quantity-selector:update).
    // Tippt jemand direkt ins Feld, kommt input/change — deshalb beides.
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.onAenderung);
    this.#section.addEventListener("input", this.onAenderung);
    this.#section.addEventListener("change", this.onAenderung);

    this.#hervorheben(this.#aktuelleMenge());
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.onAenderung);
    this.#section.removeEventListener("input", this.onAenderung);
    this.#section.removeEventListener("change", this.onAenderung);
  }

  get #section() {
    return document.getElementById(`shopify-section-${this.sectionId}`) || document;
  }

  #aktuelleMenge() {
    const feld = this.#section.querySelector("input.quantity-input");
    return feld ? parseInt(feld.value, 10) : 1;
  }

  /** Markiert die Stufe, in der die gewählte Menge liegt. */
  #hervorheben(menge) {
    if (!Number.isFinite(menge) || menge < 1) menge = 1;

    for (const zeile of this.zeilen) {
      const ab = parseInt(zeile.dataset.ab, 10);
      const bis = parseInt(zeile.dataset.bis, 10);
      // bis = 0 bedeutet "nach oben offen" (oberste Stufe)
      const trifft = menge >= ab && (bis === 0 || menge <= bis);
      zeile.classList.toggle("is-aktiv", trifft);
    }
  }
}

if (!customElements.get("staffelpreise-tabelle")) {
  customElements.define("staffelpreise-tabelle", StaffelpreiseTabelle);
}
